module.exports = {"id":"225877","name":"Bernardo Medina","rating":"71","photo":"./data/images/photos/4/225877.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BernardoMedina0.json
// module id = 591
// module chunks = 0